import styled from "@emotion/native";
import { ViewStyle } from "react-native";
import Text from "../../components/Text";
import { AppTheme } from "../../utils/theme";
import { Platform, Dimensions } from "react-native";
import * as drawer from "../../utils/drawer";

const { height } = Dimensions.get("window");

export const StackContainer = styled.View(
	{
		flex: 1,
	},
	({ theme }: any) => {
		const {
			color: { backgroundAccent },
		} = theme as AppTheme;

		return {
			backgroundColor: backgroundAccent,
		};
	}
);

export const Container = styled.View(
	{
		flex: 1,
		justifyContent: "flex-start",
	},
	({ theme }: any) => {
		const {
			color: { backgroundAccent },
		} = theme as AppTheme;

		return {
			backgroundColor: backgroundAccent,
		};
	}
);

export const Body = styled.ScrollView(
	{
		flex: 1,
		marginTop: height * 0.13,
		paddingTop: 30,
		paddingHorizontal: 12,
		overflow: Platform.OS === "android" ? "scroll" : "hidden",
	},
	({ theme }: any) => {
		const {
			color: { backgroundAccent },
		} = theme as AppTheme;
		return {
			backgroundColor: backgroundAccent,
		};
	}
);

export const Title = styled(Text)({
	paddingHorizontal: 13,
	marginBottom: 10,
});

export const ResourceCategoryList = styled.View({
	paddingHorizontal: 12,
});

export const NoResultsContainer = styled.View({
	paddingHorizontal: 12,
});

export const NoResultsMessage = styled(Text)({
	marginVertical: 20,
	marginHorizontal: 20,
});

export const RedoContainer = styled.View(
	{
		position: "absolute",
		right: drawer.BUTTON_LEFT,
		top: drawer.BUTTON_TOP,
		width: 100,
		marginTop: drawer.BUTTON_HEIGHT / 2,
		flexDirection: "row",
		justifyContent: "flex-end",
		alignContent: "flex-end",
	},
	({ theme, hidden }: any) => {
		let style: ViewStyle = {};

		if (hidden) {
			style = {
				display: "none",
			};
		}

		if (theme.verticalScale < 1) {
			const right = drawer.BUTTON_LEFT * theme.verticalScale;
			const top = drawer.BUTTON_TOP * theme.verticalScale;
			const marginTop = (drawer.BUTTON_HEIGHT * theme.verticalScale) / 2;

			style = {
				...style,
				right,
				top,
				marginTop,
			};
		}

		return style;
	}
);

export const SearchFormContainer = styled.View({
	paddingHorizontal: 12,
});

export const KeyboardAvoidingView = styled.KeyboardAvoidingView(
	({ hidden }: any) => {
		return {
			marginTop: 20,
			justifyContent: "flex-start",
			alignItems: "center",
			flexDirection: "column",
			display: hidden ? "none" : "flex",
		};
	}
);

export const TextInput = styled.TextInput(
	{
		paddingHorizontal: 20,
		height: 50,
		borderRadius: 5,
		marginVertical: 20,
		width: 230,
	},
	({ theme }: any) => {
		return {
			backgroundColor: theme.color.text,
			color: theme.color.inputText,
		};
	}
);

export const EnterZipCodeLabel = styled(Text)({
	textAlign: "center",
});

export const ZipCodeUsage = styled(Text)({
	marginVertical: 20,
	marginHorizontal: 20,
});
